<template>
    <div class="handy-purchase">
        <!-- 商品列表 -->
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadGoods"
            class="goods-list"
        >
            <div v-for="(item, index) in goodsList" :key="item.id" class="goods-item">
                <van-card
                    :thumb="item.images_info && item.images_info[0] ? item.images_info[0].url : ''"
                    :title="item.title"
                    class="goods-card"
                >
                    <template #price>
                        <div class="price-info">
                            <span v-if="item.integral > 0" class="integral">{{ item.integral }}积分</span>
                            <span v-if="item.integral > 0 && item.amount > 0" class="plus">+</span>
                            <span v-if="item.amount > 0" class="amount">{{ item.amount }}元</span>
                        </div>
                    </template>
                    <template #num>
                        <van-stepper
                            v-model="item.quantity"
                            min="0"
                            :max="item.stock_num || 99"
                            @change="onQuantityChange(item)"
                            class="quantity-stepper"
                        />
                    </template>
                </van-card>
            </div>
        </van-list>

        <!-- 结算栏 -->
        <van-submit-bar
            :loading="isLoading"
            :decimal-length="0"
            currency=""
            label=""
            suffix-label=""
            button-text="立即购买"
            @submit="onSubmit"
            :disabled="totalCount === 0"
            class="submit-bar"
        >
            <template #default>
                <!-- <div class="total-info">
                  <span class="total-count">共{{ totalCount }}件</span>
                  <span v-if="totalIntegral > 0" class="total-integral">{{ totalIntegral }}积分</span>
                  <span v-if="totalIntegral > 0 && totalAmount > 0">+</span>
                  <span v-if="totalAmount > 0" class="total-amount">{{ totalAmount }}元</span>
                </div> -->
                <span class="total-count">共{{ totalCount }}件</span>
                <div v-if="totalCount > 0" class="price">
                    合计:
                    <span class="number" style="padding-left: 5px;" v-if="totalAmount > 0">{{ totalAmount }}<span
                        class="unit">元</span></span>
                    <span class="number" v-if="totalIntegral > 0 && totalAmount > 0">+</span>
                    <span class="number" v-if="totalIntegral > 0">{{ totalIntegral }}<span
                        class="unit">积分</span></span>
                </div>
            </template>
        </van-submit-bar>
    </div>
</template>

<script>
import api from '../../assets/js/api'
import common from '../../assets/js/common'

export default {
    name: 'HandyPurchase',
    data () {
        return {
            goodsList: [],
            loading: false,
            finished: false,
            page: 1,
            pageSize: 20,
            orderDetail: {},
            hasServerTotals: false,
            checkoutTimer: null,
            isLoading: false,
            siteId: null
        }
    },
    computed: {
        // 计算总数量
        totalCount () {
            return this.goodsList.reduce((sum, item) => sum + (item.quantity || 0), 0)
        },
        // 计算总积分
        totalIntegral () {
            if (this.hasServerTotals) {
                return (this.orderDetail.total_integral || 0)
            }
            return this.goodsList.reduce((sum, item) => sum + (item.integral || 0) * (item.quantity || 0), 0)
        },
        // 计算总金额
        totalAmount () {
            if (this.hasServerTotals) {
                return (this.orderDetail.total_amount || 0)
            }
            return this.goodsList.reduce((sum, item) => sum + (item.amount || 0) * (item.quantity || 0), 0)
        }
    },
    created () {
        this.siteId = (this.$route.query && this.$route.query.site_id) || (this.$route.params && this.$route.params.site_id) || null
        this.loadGoods()
    },
    methods: {
        // 加载商品列表
        loadGoods () {
            api.request('/integral_goods/list', {
                page: this.page,
                page_size: this.pageSize,
                is_handy: true  // 只获取随手购商品
            }).then(res => {
                console.log(res)
                const goods = res.data.data || []

                // 为每个商品添加quantity属性，默认为0
                goods.forEach(item => {
                    item.quantity = 0
                })

                if (this.page === 1) {
                    this.goodsList = goods
                } else {
                    this.goodsList.push(...goods)
                }

                this.loading = false

                if (!res.data.has_next_page) {
                    this.finished = true
                } else {
                    this.page++
                }
            }).catch(err => {
                this.loading = false
                this.finished = true
                this.$toast.fail('加载商品失败')
            })
        },

        // 数量变化处理
        onQuantityChange (item) {
            if (this.checkoutTimer) {
                clearTimeout(this.checkoutTimer)
            }
            const selectedGoods = this.goodsList.filter(g => (g.quantity || 0) > 0)
            if (selectedGoods.length === 0) {
                this.hasServerTotals = false
                this.orderDetail = {}
                this.$forceUpdate()
                return
            }
            const exchangeData = selectedGoods.map(g => ({goods_id: g.id, number: g.quantity}))
            this.checkoutTimer = setTimeout(() => {
                api.request('/integral_goods/checkout', {exchange_data: exchangeData})
                    .then(res => {
                        this.orderDetail = res.data.order_detail || {}
                        this.hasServerTotals = true
                        this.$forceUpdate()
                    })
                    .catch(() => {
                        this.hasServerTotals = false
                    })
            }, 300)
        },

        // 提交订单
        onSubmit () {
            if (this.isLoading) return
            // 过滤出数量大于0的商品
            const selectedGoods = this.goodsList.filter(item => item.quantity > 0)

            if (selectedGoods.length === 0) {
                this.$toast('请选择商品')
                return
            }

            // 构建结算数据
            const exchangeData = selectedGoods.map(item => ({
                goods_id: item.id,
                number: item.quantity
            }))

            this.isLoading = true
            api.request('/integral_goods/exchange', {
                exchange_data: exchangeData,
                site_id: this.siteId
            }).then(res => {
                if (res.data && res.data.payment_info) {
                    const paymentInfo = JSON.parse(res.data.payment_info)
                    const orderData = res.data.user_integral_order
                    common.wechatPayReady(paymentInfo.appId, () => {
                        wx.chooseWXPay({
                            timestamp: paymentInfo.timeStamp,
                            nonceStr: paymentInfo.nonceStr,
                            package: paymentInfo.package,
                            signType: paymentInfo.signType,
                            paySign: paymentInfo.paySign,
                            success: () => {
                                this.$toast({
                                    message: '兑换成功',
                                    onClose: () => {
                                        this.$router.push({
                                            name: 'IntegralOrderDetail',
                                            query: {orderNo: orderData.order_no}
                                        })
                                    }
                                })
                            },
                            cancel: () => {
                                this.$router.push({
                                    name: 'IntegralOrderDetail',
                                    query: {orderNo: orderData.order_no}
                                })
                            },
                            fail: (resErr) => {
                                this.$toast(resErr.errMsg)
                            }
                        })
                    })
                } else {
                    this.$toast.success(res.msg)
                    this.$router.push({
                        name: 'IntegralOrderDetail',
                        query: {orderNo: res.data.user_integral_order.order_no}
                    })
                }
            }).catch(resErr => {
                this.$toast.fail(resErr.msg || '兑换失败')
            }).finally(() => {
                this.isLoading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/themeify.scss';

* {
    @include themeify {
        .theme-text-color {
            color: themed('colorText')
        }

        /deep/ .van-submit-bar {
            .van-submit-bar__price {
                color: themed('colorText')
            }

            .van-submit-bar__button--danger {
                color: #FFF;
                background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
            }
        }

        .price {
            flex: 1;
            padding: 0 10px;
            font-size: 14px;
            color: #333;

            .number {
                color: rgb(243, 9, 75);
                font-size: 16px;

                .unit {
                    font-size: 12px;
                }
            }
        }
    }
}


.handy-purchase {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding-bottom: 100px;
}

.goods-list {
    background-color: #fff;
}

.goods-item {
    margin-bottom: 10px;
    background-color: #fff;
}

.goods-card {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 10px;
}

.price-info {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.integral {
    color: #ff6b35;
    font-weight: bold;
}

.plus {
    margin: 0 5px;
    color: #999;
}

.amount {
    color: #333;
}

.quantity-stepper {
    margin-top: 10px;
}

.submit-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.total-info {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.total-count {
    color: #333;
    margin-right: 5px;
}

.total-integral {
    color: #ff6b35;
    font-weight: bold;
    margin-right: 5px;
}

.total-amount {
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/HandyPurchase.vue